import { render, staticRenderFns } from "./RecommendedPlaylist.vue?vue&type=template&id=c4c0ddd4"
import script from "./RecommendedPlaylist.vue?vue&type=script&lang=js"
export * from "./RecommendedPlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports